<template>
  <Layout>
    <div class="container body-content">
      <h2>Announcements</h2>
      
      <div class="col-md-8">
        <table 
          v-for="announcement in announcements" 
          :key="announcement.id"
          class="announcement table-spaced table-responsive"
          :id="'aId-' + announcement.id"
        >
          <tbody>
            <tr class="h-blue">
              <td colspan="4">{{ announcement.title }}</td>
            </tr>
            <!-- <tr class="bg-blue">
              <td class="announcement-label">Posted On</td>
              <td class="announcement-info">{{ announcement.postedOn }}</td>
              <td class="announcement-label">Posted By</td>
              <td class="announcement-info">{{ announcement.postedBy }}</td>
            </tr>
            <tr class="bg-blue">
              <td class="announcement-label">Audience</td>
              <td colspan="3" class="announcement-info">{{ announcement.audience }}</td>
            </tr> -->
            <tr>
              <td colspan="4" class="announcement-message" v-html="announcement.message"></td>
            </tr>
            <tr>
              <td colspan="4" class="announcement-controls">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Layout>
</template>

<script>
  // 获取公告列表
import { apiService } from '@/config/api'
import Layout from '@/components/Layout.vue'

export default {
  name: 'Announcements',
  components: {
    Layout
  },
  data() {
    return {
      announcements: [
        {
          id: 255,
          title: 'Registration for The Asian and Oceania Workshop on Data, Inference and Security Opens Now!',
          postedOn: '11/02/2025 6:37:14 PM',
          postedBy: 'Ji Chen (ISACI Secretary General)',
          audience: 'All Users',
          message: `The Asian and Oceania Workshop on Data, Inference and Security
Dates: 14 – 16 November 2025
Location: Penang, Malaysia
Organised by: International Society for Applied and Computational Imaging (ISACI)

Overview
  The Asian and Oceania Workshop on Data, Inference and Security brings together researchers, scholars, and professionals across disciplines to explore the latest developments in data-driven modelling, computational inference, and information security.
  This workshop serves as a collaborative platform for the academic community in the Asia–Pacific and Oceania regions, fostering dialogue, exchange of ideas, and partnership opportunities in applied and computational imaging.

Programme
Day 1 (14 Nov) – Arrival and Registration
Day 2 (15 Nov) – Technical Sessions and Visit to Universiti Sains Malaysia (USM)
Day 3 (16 Nov) – Workshop Sessions and Closing Discussion

Registration
Contact
For all workshop-related enquiries, please reach out to:
Email: isaci.contact@gmail.com`
        }
      ]
    }
  },
  mounted() {
    // this.getAnnouncements()
  },
  methods: {
    getAnnouncements() {
      apiService.announcements.getList().then(response => {
        this.announcements = response.data.data.list
      })
    }
  }
}
</script>

<style scoped>
.container.body-content {
  padding: 0px;
  max-width: 1200px;
  margin: 0 auto;
  margin-left: 0px;
}

h2 {
  color: #333;
  margin-bottom: 20px;
}

.announcement {
  margin-bottom: 30px;
  /* border: 1px solid #ddd; */
  border-radius: 4px;
  overflow: hidden;
}

.announcement table {
  width: 100%;
  border-collapse: collapse;
}

.announcement td {
  padding: 12px;
  border: none;
}

.h-blue {
  background-color: #337ab7;
  color: white;
  font-weight: bold;
}

.h-blue td {
  padding: 15px 12px;
  font-size: 16px;
}

.bg-blue {
  background-color: #f5f5f5;
}

.announcement-label {
  font-weight: bold;
  color: #333;
  width: 120px;
}

.announcement-info {
  color: #666;
}

.announcement-message {
  background-color: white;
  padding: 20px 12px;
  line-height: 1.6;
  color: #333;
  white-space: pre-line;
}

.announcement-controls {
  background-color: #f9f9f9;
  padding: 10px 12px;
}

.table-spaced {
  margin-bottom: 20px;
}

.table-responsive {
  overflow-x: auto;
}

/* 强制col-md-8在所有屏幕尺寸下都是100%宽度 */
.col-md-8 {
  width: 100% !important;
  max-width: 100% !important;
  flex: 0 0 100% !important;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .col-md-8 {
    width: 100% !important;
    max-width: 100% !important;
  }
  
  .announcement-label {
    width: 100px;
  }
  
  .h-blue td {
    font-size: 14px;
    padding: 12px 8px;
  }
  
  .announcement td {
    padding: 8px;
  }
  
  .announcement-message {
    padding: 15px 8px;
  }
}
</style> 